// Steps to mint an Anubis NFT

import React, { useState } from "react";
import CopyButton from "./CopyButton/CopyButton";

const Mint = () => {
  // Keeps track of the string copied, to show 'copied' message beside the correct field
  const [copyState, setcopyState] = useState("");
  return (
    <div
      className="section-container flex flex-col items-center px-4"
      id="mint"
    >
      <h3 className="section-title">How to Mint</h3>
      <div className="font-content px-2 text-left md:text-center text-sm sm:text-base md:text-lg list-decimal leading-loose">
        <li className="mb-5">
          Make a metamask account on{" "}
          <a
            href="https://metamask.io"
            className="underline"
            target="_blank"
            rel="noreferrer"
          >
            metamask.io
          </a>
        </li>
        <li className="leading-snug mb-3">
          Activate the matic mainnet by clicking on custom rpc and entering
          information given below:
        </li>

        {/* Copy-able form fields */}
        <div className="leading-snug w-fit md:mx-auto">
          <label htmlFor="network-name" className="text-sm ">
            Network Name
          </label>
          <br></br>
          <div className="flex justify-center">
            <input
              type="text"
              className="text-sm lg:text-lg px-1 rounded-sm lg:ml-6"
              value="Polygon"
              name="network-name"
              disabled
            ></input>
            <CopyButton
              text="Polygon"
              copyState={copyState}
              setcopyState={setcopyState}
            />
          </div>
          <label htmlFor="new-rpc-url" className="text-sm ">
            New RPC URL
          </label>
          <br></br>
          <div className="flex justify-center">
            <input
              type="text"
              className="text-sm lg:text-lg px-1 rounded-sm lg:ml-6"
              value="https://polygon-rpc.com"
              name="new-rpc-url"
              disabled
            ></input>
            <CopyButton
              text="https://polygon-rpc.com"
              copyState={copyState}
              setcopyState={setcopyState}
            />
          </div>
          <label htmlFor="chain-id" className="text-sm ">
            Chain ID
          </label>
          <br></br>
          <div className="flex justify-center">
            <input
              type="text"
              className="text-sm lg:text-lg px-1 rounded-sm lg:ml-6"
              value="137"
              name="chain-id"
              disabled
            ></input>
            <CopyButton
              text="137"
              copyState={copyState}
              setcopyState={setcopyState}
            />
          </div>
          <label htmlFor="curr-symbol" className="text-sm ">
            Currency Symbol (optional)
          </label>
          <br></br>
          <div className="flex justify-center">
            <input
              type="text"
              className="text-sm lg:text-lg px-1 rounded-sm lg:ml-6"
              value="MATIC"
              name="curr-symbol"
              disabled
            ></input>
            <CopyButton
              text="MATIC"
              copyState={copyState}
              setcopyState={setcopyState}
            />
          </div>
          <label htmlFor="BE-url" className="text-sm ">
            Block Explorer URL (optional)
          </label>
          <br></br>
          <div className="flex justify-center">
            <input
              type="text"
              className="text-sm lg:text-lg px-1 rounded-sm lg:ml-6 mb-2"
              value="https://polygonscan.com"
              name="BE-url"
              disabled
            ></input>
            <CopyButton
              text="https://polygonscan.com"
              copyState={copyState}
              setcopyState={setcopyState}
            />
          </div>
        </div>
        <li className="mb-5">
          Add matic to your account using binance, kucoin, coinbase etc.
          <br></br>
          <span className="text-base text-egyptian-gold">
            Tip: when sending funds through binance send only using the polygon
            chain. If you send using binance chain the funds will be stuck.
          </span>
        </li>
        <li className="mb-5">
          Connect your wallet to the CryptoGods: Anubis minting page and make
          sure you have sufficient funds.
        </li>
        <li className="mb-5">
          Approve the transaction and you would have successfully minted an
          Anubis token, which you can see on your opensea account.
        </li>
      </div>
    </div>
  );
};
export default Mint;
